import * as types from "../../redux/types";
import backend from "../../api/api";
import { store } from "../../redux/store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createService = (formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.post(
      "api/contact/service/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllService = () => async () => {
  try {
    const response = await backend.get(
      "api/contact/service/",
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificService = (id) => async () => {
  console.log(id)
  try {
    const response = await backend.get(
      `api/contact/service/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteService = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/contact/service/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return response;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateService = (id, formValues) => async (dispatch) => {
  formValues["data"] = "";
  try {
    const response = await backend.patch(
      `api/contact/service/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
    // message.success(formValues["name"] + " Has been Updated");
  } catch (error) {
    console.log(error.response);
  }
};



// Service Schedule
export const createSchedule = (formValues, service_id) => async () => {
  // formValues["data"] = "";
  formValues.service = service_id;
  try {
    const response = await backend.post(
      "api/contact/schedule/",
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      message.success("Service Schedule created successfully");
      const serviceSchedule = response.data;
      return serviceSchedule;
    } else {
      throw new Error("Error creating Schedule");
    }
  } catch (error) {
    console.log(error);
  }
};

// READ
export const getSchedule = async (id) => {
  try {
    const response = await backend.get(
      `api/contact/schedule/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching draft order:", error);
    throw error;
  }
};

export const getAllSchedule = () => async () => {
  try {
    const response = await backend.get(`api/contact/schedule/`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching schedule:", error);
    throw error;
  }
};

// UPDATE
export const updateSchedule = (id, formValues) => async () => {
  try {
    const response = await backend.patch(
      `api/contact/schedule/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      message.success("Schedule created successfully");
      const service = response.data;
      return service;
    } else {
      throw new Error("Error creating draft order");
    }
  } catch (error) {
    console.log(error);
  }
};

// DELETE
export const deleteSchedule = (id) => async () => {
  try {
    const response = await backend.delete(
      `api/contact/schedule/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      message.success("Schedule deleted successfully");
    }
  } catch (error) {
    console.error("Error deleting schedule:", error);
    throw error;
  }
};



export const getServiceSchedules = (serviceId) => async () => {
  try {
    const response = await backend.get(`api/contact/service/${serviceId}/schedules/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
    // return response.data;
  } catch (error) {
    console.error("Error fetching service schedules:", error);
    throw error;
  }
};

